module.exports = __webpack_public_path__ + "static/media/13ITC4.eeacb0b3.jpg";